import React from 'react';
import './WhatsappButton.css';

const WhatsappButton = ({ telefono, texto, tooltip }) => {
  const handleClick = () => {
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(texto)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="whatsapp-tooltip-container">
      <button className="whatsapp-button" onClick={handleClick}>
        <img src="/assets/images/wz-icon.png" alt="Whatsapp" style={{ width: '60px', maxWidth: '100%' }} />
      </button>
      <span className="whatsapp-tooltip">{tooltip}</span>
    </div>
  );
};

export default WhatsappButton;
